import { useState, useCallback } from 'react';
import { useInjection } from '../../../di_container/InjectionProvider';
import { JobOffer, ReviewPost, SubmitFromWorker, User, WorkerCounter } from '../../firestore_model/job';
import { pagination } from '../../../common/constants/Constants';
export const useJobUser = () => {
    const { container } = useInjection();
    const [loadingJobUser, setLoadingJobUser] = useState(false);
    const [loadingReview, setLoadingReview] = useState(false);
    const [loadingJobHistory, setLoadingJobHistory] = useState(false);
    const [loadingPostedReview, setLoadingPostedReview] = useState(false);
    // ユーザープロフィール情報
    const loadJobUser = useCallback(async (userId) => {
        setLoadingJobUser(true);
        try {
            const jobUser = await User.get(userId);
            setLoadingJobUser(false);
            return jobUser;
        }
        catch (e) {
            setLoadingJobUser(false);
            throw e;
        }
    }, []);
    // 提出書類を取得
    const loadSubmitDocuments = useCallback(async (jobOffer, userId) => {
        const result = await SubmitFromWorker.get(jobOffer.submitFromWorker.collectionReference.doc(userId));
        return result;
    }, []);
    // レビュー平均
    const loadReviewRatingAve = useCallback(async (userId) => {
        var _a;
        const path = new User(userId).workerCounter.collectionReference.doc('v1');
        const workerCounter = await WorkerCounter.get(path);
        return {
            data: (_a = workerCounter) === null || _a === void 0 ? void 0 : _a.data(),
        };
    }, []);
    // レビュー一覧
    const loadReviewList = useCallback(async (userId, lastDocument) => {
        setLoadingReview(true);
        try {
            const path = new User(userId).reviewPostsFromClinic.collectionReference.path;
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoadingReview(false);
            return {
                data: result.docs.map((item) => ReviewPost.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoadingReview(false);
            throw e;
        }
    }, []);
    // 業務履歴
    const loadJobHistoriesList = useCallback(async (userId, lastDocument) => {
        setLoadingJobHistory(true);
        try {
            const path = new User(userId).jobHistories.collectionReference.path;
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoadingJobHistory(false);
            return {
                data: result.docs.map((item) => JobOffer.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoadingJobHistory(false);
            throw e;
        }
    }, []);
    // 登録済みレビュー1件取得
    const loadPostedReview = useCallback(async (workerId, clinicId, jobOfferId) => {
        setLoadingPostedReview(true);
        try {
            const path = new User(workerId).reviewPostsFromClinic.collectionReference.path;
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path,
                isGroup: false,
                whereList: [
                    { fieldPath: 'clinicId', opStr: '==', value: clinicId },
                    { fieldPath: 'jobOfferId', opStr: '==', value: jobOfferId },
                ],
                limit: pagination.limit,
            });
            setLoadingPostedReview(false);
            const postedReview = result.docs.map((item) => ReviewPost.fromSnapshot(item));
            return postedReview.length > 0 ? postedReview[0] : undefined;
        }
        catch (e) {
            setLoadingPostedReview(false);
            throw e;
        }
    }, []);
    return {
        loadJobUser,
        loadSubmitDocuments,
        loadReviewRatingAve,
        loadReviewList,
        loadJobHistoriesList,
        loadPostedReview,
        loadingJobUser,
        loadingReview,
        loadingJobHistory,
        loadingPostedReview,
    };
};
